'use es6';

import React from 'react';
import GoodDetailsContainer from './GoodDetailsContainer';

var GoodDetailsReviewContainer = function GoodDetailsReviewContainer(props) {
  return React.createElement(GoodDetailsContainer, Object.assign({}, props, {
    reviewMode: true
  }));
};

export default GoodDetailsReviewContainer;